import { useMemo } from 'react';
/**
 * Returns the video type: LS, DS, or SV (or null) (abbreviations used because this powers utm params)
 */
export const useVideoType = (video) => {
    return useMemo(() => {
        if (video) {
            if (video.video_type === 'live_stream') {
                return 'ls';
            }
            if (video.showroom) {
                return 'ds';
            }
            return 'sv';
        }
        return null;
    }, [video]);
};
